import { RouteObject } from 'react-router-dom'
import FinanceOnboardingPage from '../components/FinanceOnboardingPage'

// Registered as a top-level route, deliberately outside DashboardLayout — that layout
// renders the authenticated shell. Not lazy: this is the first paint a vendor sees.
export const FinanceOnboardingRoute: RouteObject = {
    path: '/finance',
    element: <FinanceOnboardingPage />,
}

export default FinanceOnboardingRoute
